<div [ngClass]="{'card': true, 'w-full': full}" >
    <ng-content></ng-content>
</div>
